export default __webpack_public_path__ + "static/media/finetic-logo-light-small.f3811213.png";